import { React, useContext, useEffect, useState } from "react";
import Sidebar from "../../Components/Sidebar/sidebar";
import { Layout } from "antd";
import { Routes, Route } from "react-router-dom";
import HeaderNav from "../../Components/Header/Header";
import AddNewPoData from "./AddNewPO/addNewPO";
import OrderRecordsData from "./OrderRecords/orderRecords";
import PoDetailsData from "./AddNewPO/poDetails";
import ApproveOrdersData from "./ApproveProcess/approveOrders";
import OrderDetailsData from "./AddNewPO/orderDetails";
import ExportOrders from "./ExportOrders/exportOrders";
// import ExportOrdersPdf from "./ExportOrders/exportOrdersPdf";
import UploadPO from "./AddNewPO/importPO";
import ExportOrdersPdf from "../Exports/exportOrdersPdf";
import POValidationData from "./AddNewPO/poValidation";
import UploadedOrdersData from "./AddNewPO/uploadedOrders";
import { useNavigate } from "react-router-dom";
import PreparingUploadOrders from "./AddNewPO/preparingUploadOrders";
import LogTable from "../../Components/Log/logTable";
import ExportRecordsAnimation from "../Exports/exportRecordsAnimationScreen";
import AddNewSoData from "./AddNewPO/addNewSO";
import { getWorkflowSettings } from "../../Services/workFlowSettingsServices";
import FetchingOrderScreen from "./OrderRecords/FetchingOrderScreen";
import ReviewConflictingOrders from "./ConflictingOrders/reviewConflictingOrders";
import UploadSummary from "./AddNewPO/UploadSummary";
import UploadedPoOrders from "./AddNewPO/UploadedPoOrders";
const { Content } = Layout;

const OrderEntryData = (props) => {
  const [orderManagementSettings, setOrderManagementSettings] = useState({});
  const [deckleManagementSettings, setDeckleManagementSettings] = useState({});
  // const [finalMenuList, setFinalMenuList] = useState([]);
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );

  const listItems =
    (userDetails?.roles.order_records.edit_all ||
      userDetails?.roles.order_records.edit_own ||
      userDetails?.roles.order_records.view_all ||
      userDetails?.roles.order_records.view_own) &&
    userDetails?.roles.approve_orders.edit &&
    ( orderManagementSettings?.approval_flow?.value)
      ? [
          {
            icon: "order-entry-icon",
            label: "Order Records",
            link: "order-records",
          },
          {
            icon: "file-checked-icon",
            label: "Approve Orders",
            link: "approve-records",
          },
        ]
      : userDetails?.roles.approve_orders.edit &&
           ( orderManagementSettings?.approval_flow?.value)

      ? [
          {
            icon: "file-checked-icon",
            label: "Approve Orders",
            link: "approve-records",
          },
        ]
      : [
          {
            icon: "order-entry-icon",
            label: "Order Records",
            link: "order-records",
          },
        ];
  useEffect(() => {
    if (!userDetails) {
      navigate("/login");
    }
  }, [userDetails]);
  useEffect(async () => {
    let orderMangtSettings = await getWorkflowSettings("order_management");

    setOrderManagementSettings(orderMangtSettings?.data);
    let deckleMangtSettings = await getWorkflowSettings("deckle_management");
    setDeckleManagementSettings(deckleMangtSettings?.data);
  }, []);
  return (
    <Layout>
      <HeaderNav />
      <Layout>
        <Sidebar headerName="ORDER MANAGEMENT" listItems={listItems} />
        <Layout>
          <Content>
            <Routes>
              <Route path="order-records" element={<OrderRecordsData />} />
              <Route
                path="order-records/export-orders"
                element={<ExportOrders />}
              />
              <Route
                path="order-records/export-orders/pdf"
                element={<ExportOrdersPdf />}
              />
              <Route path="add-new-po" element={<AddNewPoData />} />
              <Route
                path="add-new-so"
                element={<AddNewSoData isView={false} isEditMode={false} />}
              />
              <Route path="so-details" element={<AddNewSoData />} />
              <Route path="po-details" element={<PoDetailsData />} />
              <Route path="order-details" element={<OrderDetailsData />} />
              <Route path="approve-records" element={<ApproveOrdersData />} />
              <Route
                path="approve-records/export-orders"
                element={<ExportOrders />}
              />
              <Route
                path="approve-records/export-orders/pdf"
                element={<ExportOrdersPdf />}
              />
              <Route path="order-records/upload-po" element={<UploadPO />} />
              <Route
                path="order-records/preparing-upload-orders"
                element={<PreparingUploadOrders />}
              />
              <Route
                path="order-records/po-validation"
                element={<POValidationData />}
              />
              <Route
                path="order-records/uploaded-orders"
                element={<UploadedOrdersData />}
              />
              <Route path="history" element={<LogTable />} />
              <Route
                path="order-records/preparing-export-orders"
                element={<ExportRecordsAnimation />}
              />
              <Route
                path="approve-records/preparing-export-orders"
                element={<ExportRecordsAnimation />}
              />
              <Route path='order-records/fetching-order' element={<FetchingOrderScreen />} />
              <Route path="review-conflicting-orders" element={<ReviewConflictingOrders />} />
              <Route path="order-records/upload-summary" element={<UploadSummary/>} />
              <Route path="order-records/uploaded-orders-under-po" element={<UploadedPoOrders/>} />              
            </Routes>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default OrderEntryData;
